import { render } from "./FormatDate.vue?vue&type=template&id=c2f479f8&ts=true"
import script from "./FormatDate.vue?vue&type=script&lang=ts"
export * from "./FormatDate.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__